import http from "@/common/http.service";
const GET_CONTACT_SUMMARY = "contact/contact-summary";

export default {
  fetchContactSummary(params, cb) {
    // alert(5)
    http.post(GET_CONTACT_SUMMARY, params).then(function (response) {
      var data = response.data.data;
      cb(data);
    });
  },
};
